module.exports = "<div class=\"loading-overlay\" id=\"loader\" [class.hide]=\"!loading\"></div>\r\n<app-menu menuId=\"header-menu\" [class.hide]=\"loading\"></app-menu>\r\n<app-header></app-header>\r\n<div class=\"site-wrap\" [class.hide]=\"loading\">\r\n    <router-outlet></router-outlet>\r\n    <app-footer></app-footer>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// E:/MBP/BloomyNG/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main